import Rx from 'rxjs';
import Cookies from 'js-cookie';

const open = Cookies.get('sidebarStatus') === undefined ? true : !!+Cookies.get('sidebarStatus');
const toggleSideBar = new Rx.Subject()
  .map(value => state => Object.assign({}, state, { open: value }));

const state = toggleSideBar
  .scan((states, changeFn) => changeFn(states), { open: true })
  .startWith({ open });

const changeStatus = (value) => {
  Cookies.set('sidebarStatus', value ? 1 : 0);
  toggleSideBar.next(value);
};

export default {
  state,
  changeStatus
};



// WEBPACK FOOTER //
// ./src/store/sideBar.js